@if (showLogo) {
  <div class="splash-logo centered">
    <img src="assets/icons/buildevo_logo.svg" alt="Empty Activities" />
  </div>
}

<div class="relative centered">
  <div class="flex flex-col leading-none text-center gap-5">
    <div class="empty-text font-light text-navy-700">{{ title }}</div>
    @if (subTitle) {
      <div class="text-size_title_m font-light text-navy-700">
        {{ subTitle }}
      </div>
    }
    <div class="mt-4 flex items-center justify-center">
      <ng-content></ng-content>
    </div>
  </div>
</div>
